import { render, staticRenderFns } from "./OrgApplicationHandlingPanel.vue?vue&type=template&id=fc82241a"
import script from "./OrgApplicationHandlingPanel.vue?vue&type=script&lang=js"
export * from "./OrgApplicationHandlingPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports